import { Container, Row, Col } from "reactstrap";
import {
    FiCheckCircle
} from "react-icons/fi";

import "./WhyLearnCourse.css";

function WhyLearnCourse({
    courseName,
    reasons
}) {

    return (
        <section className="why-learn-course">

            <Container>

                {/* Section Header */}
                <div className="why-learn-header">

                    <span className="course-section-label">
                        WHY LEARN
                    </span>

                    <h2>
                        10 Reasons to Learn {courseName}
                    </h2>

                    <p>
                        Build specialized knowledge, practical skills,
                        and industry-ready expertise through structured
                        learning and hands-on training.
                    </p>

                </div>


                {/* Reasons */}
                <Row className="g-4">

                    {reasons.map((reason, index) => (

                        <Col
                            lg="6"
                            md="6"
                            sm="12"
                            key={index}
                        >

                            <div className="why-learn-card">

                                {/* Number */}
                                <div className="why-learn-number">
                                    {String(index + 1).padStart(2, "0")}
                                </div>


                                {/* Icon */}
                                <div className="why-learn-icon">

                                    <FiCheckCircle />

                                </div>


                                {/* Content */}
                                <div className="why-learn-content">

                                    <h3>
                                        {reason.title}
                                    </h3>

                                    <p>
                                        {reason.description}
                                    </p>

                                </div>

                            </div>

                        </Col>

                    ))}

                </Row>

            </Container>

        </section>
    );
}

export default WhyLearnCourse;